import { collection } from 'firebase/firestore';
import { db } from './config';

const demosRef = collection(db, 'demos');
const usersRef = collection(db, 'users');

export { demosRef, usersRef };
